import { Plus, Trash2 } from "lucide-react";
import { Label } from "@/components/ui/label";
import { ImageUploader } from "./ImageUploader";

const aspects = ["auto", "square", "portrait", "landscape", "wide"];
const aspectFrame = {
  auto: "aspect-[4/3]",
  square: "aspect-square",
  portrait: "aspect-[3/4]",
  landscape: "aspect-[4/3]",
  wide: "aspect-[16/9]",
};

export const PhotoListEditor = ({ photos = [], onChange, testidPrefix = "photos" }) => {
  const update = (i, patch) => onChange(photos.map((p, j) => (j === i ? { ...p, ...patch } : p)));
  const remove = (i) => onChange(photos.filter((_, j) => j !== i));
  const add = () => onChange([...photos, { url: "", aspect: "landscape", fit: "cover" }]);

  return (
    <div className="space-y-4">
      <p className="text-xs text-[var(--text-muted)]">Mix a few shapes (a tall portrait next to a couple of squares looks best) — they'll flow into a pretty collage. After uploading, drag the photo to frame it and zoom in.</p>
      {photos.map((p, i) => (
        <div key={i} className="rounded-lg border border-[var(--border)] p-4 space-y-3" data-testid={`${testidPrefix}-item-${i}`}>
          <div className="flex justify-between items-center">
            <span className="text-xs text-[var(--text-muted)]">Photo {i + 1}</span>
            <button type="button" onClick={() => remove(i)} className="text-red-500" data-testid={`${testidPrefix}-remove-${i}`}><Trash2 className="w-4 h-4" /></button>
          </div>
          <div>
            <Label className="text-xs">Shape</Label>
            <select className="mt-1 w-full h-10 rounded-md border border-[var(--border)] bg-[var(--card)] px-2 text-sm text-[var(--text-primary)]" value={p.aspect || "landscape"} onChange={(e) => update(i, { aspect: e.target.value })} data-testid={`${testidPrefix}-aspect-${i}`}>
              {aspects.map((a) => <option key={a} value={a}>{a}</option>)}
            </select>
          </div>
          <ImageUploader
            value={{ url: p.url, position: p.position, zoom: p.zoom }}
            onChange={(v) => { const o = typeof v === "string" ? { url: v } : v; update(i, { url: o.url, position: o.position, zoom: o.zoom }); }}
            testid={`${testidPrefix}-upload-${i}`}
            positionable
            aspectClass={aspectFrame[p.aspect || "landscape"]}
          />
        </div>
      ))}
      <button type="button" onClick={add} className="text-sm text-[var(--gold-hover)] flex items-center gap-1" data-testid={`${testidPrefix}-add`}>
        <Plus className="w-4 h-4" /> Add photo
      </button>
    </div>
  );
};
